module.exports = require("./dist/position-calculator.min.js");


//////////////////
// WEBPACK FOOTER
// position-calculator (bower component)
// module id = 113
// module chunks = 0